import { Check } from 'lucide-react';

export interface ChecklistItem {
  key: string;
  label: string;
  ok: boolean;
  /** Sunto a destra (es. "3 campi mancanti", nome del PDF). */
  summary?: string;
  /** Evidenzia in rosso (dopo un tentativo di completamento fallito). */
  error?: boolean;
  onClick?: () => void;
}

/**
 * Checklist di stato in testa al drawer: una riga per requisito con spunta
 * verde quando è soddisfatto. Il click porta alla sezione corrispondente.
 */
export function AcceptanceChecklist({ items }: { items: ChecklistItem[] }) {
  return (
    <div className="mt-2 rounded-md border border-[rgba(55,53,47,0.09)] dark:border-white/10 divide-y divide-[rgba(55,53,47,0.06)] dark:divide-white/[0.06]">
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          onClick={item.onClick}
          className="flex w-full items-center gap-2.5 px-3 py-2 text-left hover:bg-[rgba(55,53,47,0.04)] dark:hover:bg-white/[0.04] transition-colors"
        >
          <span
            className={`flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full border ${
              item.ok
                ? 'border-[#1FA855] bg-[#1FA855] text-white'
                : item.error
                  ? 'border-[#EB5757]'
                  : 'border-[rgba(55,53,47,0.25)] dark:border-white/25'
            }`}
            aria-hidden
          >
            {item.ok && <Check className="h-2.5 w-2.5" strokeWidth={3} />}
          </span>
          <span className={`text-[13px] font-medium ${item.error && !item.ok ? 'text-[#EB5757]' : 'text-[#37352F] dark:text-white'}`}>
            {item.label}
          </span>
          {item.summary && (
            <span className="ml-auto min-w-0 truncate text-[12px] text-[#9B9A97] dark:text-gray-400">{item.summary}</span>
          )}
        </button>
      ))}
    </div>
  );
}
